// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpDownArrow_wrapper__2ptal"};